import React, { Component } from 'react';
import DATA from '../../assets/data';
import Button from '@material-ui/core/Button';
import CustomSelect from "../../components/common/select/Select";
import { connect } from "react-redux";
import AccrualReportMiddleware from '../../store/prat_middleware/accrualReport/accrualReportMiddleware';
import { Loader } from "../../components/loader/index";
import throttle from "lodash.throttle";
import { valueConverter_2 } from '../../util-functions/util-funtions'
import './accrualReport.styles.scss'

class AccrualReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedYear: 2020,
            selectedWeekFrom: '',
            selectedWeekTo: '',
            pageNo: 1,
            selectedQuarter: [],
            selectedMonth: [],
            receiveData: true,
            data: [],
            startingWeeks: [],
            endingWeeks: [],
            minWeek: '',
            maxWeek: '',
            totalData: '',
            loading: true
        };
    }

    componentDidMount() {

        setTimeout(() => {

            this.props.getAccrualReport(
                this.state.pageNo,
                this.state.selectedYear,
                this.state.selectedWeekFrom,
                this.state.selectedWeekTo,
                this.state.selectedQuarter,
                this.state.selectedMonth
            );

        }, 1000)


        this.page_wrapper.onscroll = (e) => {
            if (this.props.isAccrualReportLoading || this.state.data.length < 18) return;
            const obj = e.target;
            const height = obj.scrollHeight - obj.offsetHeight;
            const scrollPos = obj.scrollTop;
            const factor = 0.9;
            if (scrollPos >= factor * height) {
                this.load_more();
            }
        };
    }

    load_more = throttle(this.load_Data, 800, {
        trailing: false,
    });

    load_Data() {
        if (this.state.data.length === this.state.totalData || this.props.accrualReportHasError || this.props.isAccrualReportLoading) return;
        this.setState(
            {
                pageNo: this.state.pageNo + 1,
                receiveData: true
            },
            () => {
                this.props.getAccrualReport(
                    this.state.pageNo,
                    this.state.selectedYear,
                    this.state.selectedWeekFrom,
                    this.state.selectedWeekTo,
                    this.state.selectedQuarter,
                    this.state.selectedMonth
                );
            }
        );
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.accrualReport && nextProps.accrualReport.results && this.state.receiveData) {
            if (nextProps.accrualReport) {
                this.setState({
                    totalData: nextProps.accrualReport.total_count,
                    receiveData: false,
                    loading: false
                })
                this.propsReceived(nextProps.accrualReport.results);
            }
        }
    }

    propsReceived = (value) => {
        if (value) {
            value.forEach(item => (this.state.data.push(item)))
        }
    }

    handleYearChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedYear: selectedValue.value,
            });
        }
        else {
            this.setState({
                selectedYear: "",
            });
        }
    }

    handleWeekFromChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekFrom: selectedValue.value,
            });
        } else {
            this.setState({
                selectedWeekFrom: "",
            });
        }
    }

    handleWeekToChange = (selectedValue) => {
        if (selectedValue) {
            this.setState({
                selectedWeekTo: selectedValue.value,
            });
        } else {
            this.setState({
                selectedWeekTo: "",
            });
        }
    }

    handleQuarterChange = (selectedValue) => {
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedMonth: [], selectedWeekFrom: '', selectedWeekTo: '', selectedQuarter: [], startingWeeks: [] })
        }
        else {
            selectedValue.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedQuarter: arr, selectedMonth: [], selectedWeekFrom: '', selectedWeekTo: '' });
        }
    }

    getStartingWeekNumber = (d, month) => {
        d = new Date(Date.UTC(d.getFullYear(), (month - 1), 1));
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

        return [d.getUTCFullYear(), weekNo];
    }

    getEndingWeekNumber = (d, month) => {
        d = new Date(Date.UTC(d.getFullYear(), (month), 1));
        d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
        var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
        var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);

        return [d.getUTCFullYear(), weekNo];
    }

    handleMonthChange = (selectedValue) => {
        
        // let myMonth = selectedValue.quarter === 1 ? 3 : selectedValue.quarter === 2 ? 6 : selectedValue.quarter === 3 ? 9 : selectedValue.quarter === 4 ? 12 : ''
      
        let arr = [];
        if (selectedValue === null || selectedValue.length === 0) {
            this.setState({ selectedMonth: [], selectedWeekFrom: '', selectedWeekTo: '', startingWeeks: [] })
        }
        else {
            selectedValue.forEach(element => {
                arr.push(element.value);
            });
            this.setState({ selectedMonth: arr, selectedWeekFrom: '', selectedWeekTo: '' }, () => {
                this.handleFilterWeekFrom()
            });
        }
    }

    handleFilterWeekFrom = () => {
        let arr = []
        this.state.selectedMonth.forEach(item => {
            var startingWeekNumber = this.getStartingWeekNumber(new Date(), item);
            var endingWeekNumber = this.getEndingWeekNumber(new Date(), item);
            for (var i = 1; i <= endingWeekNumber[1]; i++) {
                if (i >= startingWeekNumber[1] && i <= endingWeekNumber[1]) {
                    if (arr.includes(i)) {

                    } else {

                        arr.push({ label: "WK " + i, value: i })
                    }
                }
            }
        })
        arr.sort(function (a, b) { return a.value - b.value })
        this.setState({ startingWeeks: arr })
    }

    handleSubmit = () => {

        this.setState({
            receiveData: true,
            data: [],
            pageNo: 1,
            loading: true
        },
            () => {
                this.props.getAccrualReport(
                    this.state.pageNo,
                    this.state.selectedYear,
                    this.state.selectedWeekFrom,
                    this.state.selectedWeekTo,
                    this.state.selectedQuarter,
                    this.state.selectedMonth
                )
            })

    }

    handleDownloadXlsxFile = () => {
        this.props.downloadAccrualReport(
            this.state.pageNo,
            this.state.selectedYear,
            this.state.selectedWeekFrom,
            this.state.selectedWeekTo,
            this.state.selectedQuarter,
            this.state.selectedMonth
        )
    }

    render() {
        return (
            <div className="page-container">
                <div className="heading-and-download-container">

                    <span className='component-heading'>OPSO Accrual</span>

                    {this.props.isFileDownloading ? (
                        <img style={{ width: '26px', height: '31px' }} src={require('../../assets/gifs/Downloading.gif')} alt='' />
                    ) : (
                        <img style={{ cursor: 'pointer' }} src={require('../../assets/images/downloadIcon.svg')} onClick={this.handleDownloadXlsxFile} alt='' />
                        )}
                </div>

                <div className='select-download-container'>
                    <div className="select-container">
                        <div className='filters-container-only'>
                            {this.props.isAccrualReportLoading && this.state.loading
                                ?
                                <Loader flag={true} />
                                : (
                                    <CustomSelect.MyCustomSelect
                                        placeholder={"Year"}
                                        className="select-box"
                                        isClearable={true}
                                        options={DATA.YEARS.map((item) => ({
                                            value: item.value,
                                            label: item.label,
                                        }))}
                                        onChange={this.handleYearChange}
                                        value={DATA.YEARS
                                            ? DATA.YEARS
                                                .filter(item => {       // eslint-disable-line
                                                    if (item.value === this.state.selectedYear) {
                                                        return item
                                                    }
                                                })
                                                .map(item => {
                                                    return {
                                                        value: item.value,
                                                        label: item.label
                                                    };
                                                }) : void 0}
                                    />
                                )}

                            <CustomSelect.MyCustomSelect
                                placeholder={"Quarter"}
                                allowSelectAll={true}
                                isMulti
                                options={DATA.QUARTER.map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                }))}
                                onChange={this.handleQuarterChange}
                                value={DATA.QUARTER
                                    ? DATA.QUARTER
                                        .filter(item => {
                                            return !this.state.selectedQuarter
                                                ? void 0
                                                : this.state.selectedQuarter.includes(item.value);
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        }) : void 0
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder={"Month"}
                                allowSelectAll={true}
                                isMulti
                                options={DATA.QUARTER_MONTHS.filter(item => {
                                    if (this.state.selectedQuarter) {
                                        return this.state.selectedQuarter.includes(item.quarter);
                                    }
                                    else {
                                        return item
                                    }
                                }).map((item) => ({
                                    value: item.value,
                                    label: item.name,
                                    quarter: item.quarter
                                }))}
                                onChange={this.handleMonthChange}
                                value={DATA.QUARTER_MONTHS
                                    ? DATA.QUARTER_MONTHS
                                        .filter(item => {
                                            return this.state.selectedMonth.includes(item.value);
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.name,
                                                quarter: item.quarter
                                            };
                                        }) : void 0}
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder="Week From"
                                isClearable={true}
                                className="select-box"
                                options={
                                    this.state.startingWeeks
                                        ? this.state.startingWeeks.map(item => ({
                                            value: item.value,
                                            label: item.label
                                        }))
                                        : void 0
                                }
                                onChange={this.handleWeekFromChange}
                                value={this.state.startingWeeks
                                    ? this.state.startingWeeks
                                        .filter(item => {
                                            return !this.state.selectedWeekFrom
                                                ? void 0
                                                : item.value === this.state.selectedWeekFrom;
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        })
                                    : void 0
                                }
                            />

                            <CustomSelect.MyCustomSelect
                                placeholder="Week To"
                                isClearable={true}
                                className="select-box"
                                options={this.state.selectedWeekFrom ? this.state.startingWeeks.filter(item => {
                                    return (
                                        item.value >= this.state.selectedWeekFrom
                                    )
                                }).map((item) => ({
                                    value: item.value,
                                    label: item.label,
                                })) : []}
                                onChange={this.handleWeekToChange}
                                value={DATA.WEEK_NO
                                    ? DATA.WEEK_NO
                                        .filter(item => {
                                            return !this.state.selectedWeekTo
                                                ? void 0
                                                : item.value === this.state.selectedWeekTo;
                                        })
                                        .map(item => {
                                            return {
                                                value: item.value,
                                                label: item.label
                                            };
                                        })
                                    : void 0
                                }
                            />

                        </div>

                        <Button
                            style={{ marginBottom: '16px' }}
                            variant="outlined"
                            className="submit-btn"
                            onClick={(e) => this.handleSubmit(e)}
                        >
                            SUBMIT
                    </Button>
                    </div>
                </div>
                <div className='accrual-report-table-container'
                    ref={(c) => (this.page_wrapper = c)}>

                    <div className='gap'></div>

                    <table className='accrual-report-table'>

                        <tr style={{ textAlign: 'left' }}>
                            <th className='accrual-report-table-header'>
                                Activity Code
                            </th>
                            <th className='accrual-report-table-header' style={{ width: '105px' }}>
                                Category
                            </th>
                            <th className='accrual-report-table-header' style={{ width: '85px' }}>
                                Brand
                            </th>
                            <th className='accrual-report-table-header'>
                                Project Code
                            </th>

                            <th className='accrual-report-table-header'>
                                Code
                            </th>
                            <th className='accrual-report-table-header' style={{ width: '190px' }}>
                                MSKU
                            </th>
                            <th className='accrual-report-table-header'>
                                Week Starting
                            </th>
                            <th className='accrual-report-table-header'>
                                Week Ending
                            </th>
                            <th className='accrual-report-table-header'>
                                Estimated Cost
                            </th>
                            <th className='accrual-report-table-header'>
                                Total Activity Weeks
                            </th>
                            <th className='accrual-report-table-header'>
                                Weeks in Current Month
                            </th>
                            <th className='accrual-report-table-header'>
                                Cost
                            </th>
                            <th className='accrual-report-table-header'>
                                Average Baseline
                            </th>
                            <th className='accrual-report-table-header'>
                                Incremental AWS
                            </th>
                            <th className='accrual-report-table-header'>
                                PAWS
                            </th>
                            <th className='accrual-report-table-header'>
                                GP/ton
                            </th>
                            <th className='accrual-report-table-header'>
                                DNDS Vol
                            </th>
                            <th className='accrual-report-table-header'>
                                Total Volume
                            </th>
                            <th className='accrual-report-table-header'>
                                Incremental Volume
                            </th>
                            <th className='accrual-report-table-header'>
                                ROI
                            </th>
                            <th className='accrual-report-table-header' style={{ width: '185px' }}>
                                Remarks
                            </th>
                            <th className='accrual-report-table-header' style={{ width: '175px' }}>
                                Other Details
                            </th>
                            <th className='accrual-report-table-header'>
                                Norm
                            </th>
                            <th className='accrual-report-table-header'>
                                Promotion Type
                            </th>
                            <th className='accrual-report-table-header'>
                                Activated Volume
                            </th>
                            <th className='accrual-report-table-header'>
                                Accrual Month
                            </th>
                        </tr>

                        <tbody>
                            {this.state.data ?
                                this.state.data.map((item,ind) => (
                                    <tr className='table-row' key={ind}>
                                        <td className='table-data'>{item.ActivityCode ? item.ActivityCode : '-'}</td>
                                        <td className='table-data accrual-report-tooltip'>{item.Category ? item.Category.length > 14 ? item.Category.slice(0, 14) + '...' : item.Category : '-'}
                                            <span className='accrual-report-tooltiptext'>{item.Category}</span></td>
                                        <td className='table-data accrual-report-tooltip'>{item.Brand ? item.Brand.length > 14 ? item.Brand.slice(0, 14) + '...' : item.Brand : '-'}
                                            <span className='accrual-report-tooltiptext'>{item.Brand}</span></td>
                                        <td className='table-data'>{item.ProjectCode ? item.ProjectCode : '-'}</td>
                                        <td className='table-data'>{item.MasterSkuCode ? item.MasterSkuCode : '-'}</td>
                                        <td className='table-data accrual-report-tooltip'>{item.MasterSku ? item.MasterSku.length > 24 ? item.MasterSku.slice(0, 24) + '...' : item.MasterSku : '-'}
                                            <span className='accrual-report-tooltiptext'>{item.MasterSku}</span></td>
                                        <td className='table-data'>{item.WeekStart ? item.WeekStart : '-'}</td>
                                        <td className='table-data'>{item.WeekEnd ? item.WeekEnd : '-'}</td>
                                        <td className='table-data'>{item.EstimatedCost ? valueConverter_2(item.EstimatedCost.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.TotalActivityWeeks ? item.TotalActivityWeeks.toFixed(1) : '-'}</td>
                                        <td className='table-data'>{item.WeekCurrentMonth ? item.WeekCurrentMonth.toFixed(1) : '-'}</td>
                                        <td className='table-data'>{item.Cost ? valueConverter_2(item.Cost.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.Baseline ? valueConverter_2(item.Baseline.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.ActivatedAws ? valueConverter_2(item.ActivatedAws.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.PostAws ? valueConverter_2(item.PostAws.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.GpTon ? valueConverter_2(item.GpTon.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.DndsVolume ? valueConverter_2(item.DndsVolume.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.TotalVolume ? valueConverter_2(item.TotalVolume.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.IncVolume ? valueConverter_2(item.IncVolume.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.Roi ? valueConverter_2(item.Roi) : '-'}</td>
                                        <td className='table-data accrual-report-tooltip'>{item.DetailOfOffer ? item.DetailOfOffer.length > 24 ? item.DetailOfOffer.slice(0, 24) + '...' : item.DetailOfOffer : "-"}
                                            <span className='accrual-report-tooltiptext'>{item.DetailOfOffer}</span></td>
                                        <td className='table-data accrual-report-tooltip'>{item.OtherDetails ? item.OtherDetails.length > 24 ? item.OtherDetails.slice(0, 24) + '...' : item.OtherDetails : '-'}
                                            <span className='accrual-report-tooltiptext'>{item.OtherDetails}</span></td>
                                        <td className='table-data'>{item.Norm ? item.Norm : '-'}</td>
                                        <td className='table-data'>{item.ActivityType ? item.ActivityType : '-'}</td>
                                        <td className='table-data'>{item.TotalActivatedVolume ? valueConverter_2(item.TotalActivatedVolume.toFixed(2)) : '-'}</td>
                                        <td className='table-data'>{item.AccrualMonth ? item.AccrualMonth : '-'}</td>
                                        {/* <td>{item.ActivityCode}</td>
                                    <td>{item.ActivityCode}</td> */}
                                    </tr>
                                ))
                                :
                                null}
                        </tbody>

                    </table>
                </div>
                {this.props.isAccrualReportLoading ? <div>Loading...</div> : null}

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isAccrualReportLoading: state.AccrualReportReducer.isAccrualReportLoading,
        accrualReport: state.AccrualReportReducer.accrualReport,
        accrualReportHasError: state.AccrualReportReducer.accrualReportHasError,
        isFileDownloading: state.DownloadXlxReducer.isFileDownloading

    };
};

const mapDispatchToProps = dispatch => {
    return {
        getAccrualReport: (
            pageNo,
            selectedYear,
            selectedWeekFrom,
            selectedWeekTo,
            selectedQuarter,
            selectedMonth
        ) => {
            return dispatch(AccrualReportMiddleware.getAccrualReport(
                pageNo,
                selectedYear,
                selectedWeekFrom,
                selectedWeekTo,
                selectedQuarter,
                selectedMonth
            ))
        },
        downloadAccrualReport: (
            pageNo,
            selectedYear,
            selectedWeekFrom,
            selectedWeekTo,
            selectedQuarter,
            selectedMonth
        ) => {
            return dispatch(AccrualReportMiddleware.downloadAccrualReport(
                pageNo,
                selectedYear,
                selectedWeekFrom,
                selectedWeekTo,
                selectedQuarter,
                selectedMonth
            ))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccrualReport);